import { useEffect } from "react";
import { useAuth } from "./auth";
import { AppShell } from "./components/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { FarmsPage } from "./pages/FarmsPage";
import { FieldsPage } from "./pages/FieldsPage";
import { LoginPage } from "./pages/LoginPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { PlaceholderPage } from "./pages/PlaceholderPage";
import { DocumentsPage, OperationsPage, ReportsPage, StocksPage } from "./pages/OperationsPage";
import { navigate, useLocation } from "./router";

const operationRoutes = new Set(["/campaigns", "/interventions", "/planning", "/equipment", "/team", "/settings", "/audit"]);
export function App() {
  const auth = useAuth();
  const { pathname } = useLocation();
  useEffect(() => {
    if (auth.loading) return;
    if (!auth.identity && pathname !== "/login") navigate("/login", true);
    else if (auth.identity && auth.identity.memberships.length === 0 && pathname !== "/onboarding") navigate("/onboarding", true);
    else if (auth.identity && auth.identity.memberships.length > 0 && (pathname === "/" || pathname === "/login" || pathname === "/onboarding")) navigate("/dashboard", true);
  }, [auth.loading, auth.identity, pathname]);
  if (auth.loading) return <div className="app-loader"><span /></div>;
  if (!auth.identity) return <LoginPage />;
  if (auth.identity.memberships.length === 0) return <OnboardingPage />;
  const page = pathname === "/farms" ? <FarmsPage /> : pathname === "/fields" ? <FieldsPage /> : pathname === "/stocks" ? <StocksPage /> : pathname === "/documents" ? <DocumentsPage /> : pathname === "/reports" ? <ReportsPage /> : pathname === "/dashboard" ? <DashboardPage /> : operationRoutes.has(pathname) ? <OperationsPage /> : <PlaceholderPage />;
  return <AppShell>{page}</AppShell>;
}
